// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ContentFaq_wrapper__VmnY1","item":"ContentFaq_item__6vz_f"};